module.exports = __webpack_public_path__ + "img/bg-document-0.2890ae0a.png";